export default "__VITE_ASSET__CUmYrIIj__"